export enum ReviewAction {
  openReview = 'openReview',
  closeReview = 'closeReview',
  submitReview = 'submitReview',
  removeAll = 'removeAll',
  removeWithFilters = 'removeWithFilters',
  undo = 'undo'
}
